import { createFileRoute } from "@tanstack/react-router";

import { Footer, Nav } from "../components/lidoo/chrome";
import { hreflangLinks } from "../lib/seo";
import { useI18n } from "../lib/i18n";

const FAQ_KEYS = [1, 2, 3, 4, 5, 6, 7, 8] as const;

export const Route = createFileRoute("/faq")({
  head: () => ({
    meta: [
      { title: "FAQ | sunbedly" },
      {
        name: "description",
        content:
          "Is sunbedly free? What if a club doesn’t reply? How does booking work? Answers to the questions travelers and club owners ask us most.",
      },
    ],
    links: hreflangLinks("/faq"),
  }),
  component: FaqPage,
});

export function FaqPage() {
  const { t } = useI18n();

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQ_KEYS.map((n) => ({
      "@type": "Question",
      name: t(`faq_q${n}`),
      acceptedAnswer: { "@type": "Answer", text: t(`faq_a${n}`) },
    })),
  };

  return (
    <div className="min-h-dvh bg-[#F2EFE9]">
      <script
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Nav />
      <main className="mx-auto max-w-3xl px-5 pb-20 pt-12">
        <h1 className="li-serif text-4xl font-normal leading-none  text-[#1C2430] md:text-5xl">
          {t("faq_title")}
        </h1>
        <p className="mt-4 text-base leading-relaxed text-[#5B6472]">{t("faq_sub")}</p>
        <div className="mt-10 flex flex-col">
          {FAQ_KEYS.map((n) => (
            <div key={n} className="border-t border-[#1C2430]/15 py-6">
              <h2 className="li-display text-lg font-bold tracking-tight text-[#1C2430]">
                {t(`faq_q${n}`)}
              </h2>
              <p className="mt-2 max-w-[65ch] text-sm leading-relaxed text-[#5B6472]">
                {t(`faq_a${n}`)}
              </p>
            </div>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
